import React from "react";
import {
  Switch,
  FormControlLabel,
} from "@mui/material";

export default function RemoveBackground({ removeBackground, setRemoveBackground }) {

  return (
    <FormControlLabel
      control={
        <Switch
          checked={!removeBackground}
          onChange={(e) => setRemoveBackground(!e.target.checked)}
          size="small" // Makes the switch smaller
        />
      }
      label="Fast Search"
      sx={{
        "& .MuiFormControlLabel-label": {
          fontSize: "0.875rem"
        },
      }}
    />
  );
}